module.exports = __webpack_public_path__ + "static/media/heroImg.311dc5ab.jpg";